module.exports = __webpack_public_path__ + "img/Earth.f096041e.svg";